import { render, staticRenderFns } from "./PlantVarietyOwnerForm.vue?vue&type=template&id=5b1d50eb&"
import script from "./PlantVarietyOwnerForm.vue?vue&type=script&lang=js&"
export * from "./PlantVarietyOwnerForm.vue?vue&type=script&lang=js&"
import style0 from "./PlantVarietyOwnerForm.vue?vue&type=style&index=0&id=5b1d50eb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports